import React, { useRef, useState, useEffect } from "react";
import Checkbox4 from "./componenent/checkbox/Checkbox4";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { SocketState } from "../context/SocketProvider";

function ResultPage2d() {
    const navigate = useNavigate();
    const { socket } = SocketState();
    const container = useRef(null);

    const [fromDate, setFromDate] = useState(moment().format("YYYY-MM-DD"));
    const [field, setField] = useState([
        { label: "Select All", Checked: true, id: "all" },
        { label: "00", Checked: true, id: 0 },
        { label: "10", Checked: true, id: 1 },
        { label: "20", Checked: true, id: 2 },
        { label: "30", Checked: true, id: 3 },
        { label: "40", Checked: true, id: 4 },
        { label: "50", Checked: true, id: 5 },
        { label: "60", Checked: true, id: 6 },
        { label: "70", Checked: true, id: 7 },
        { label: "80", Checked: true, id: 8 },
        { label: "90", Checked: true, id: 9 },
    ]);



    const [resultData, setResultData] = useState([]);
    const [loading, setLoading] = useState(false);

    // ✅ Fetch data via socket
    useEffect(() => {
        if (!socket) return;

        setLoading(true);

        const payload = {
            en: "MINI_LOTTERY_RESULT_HISTORY",
            data: {
                date: moment(fromDate, "YYYY-MM-DD").format("DD-MM-YYYY"),
            },
        };

        // console.log("📤 Sending request:", payload);
        socket.emit("req", payload);

        const handleResponse = (response) => {
            // console.log("📩 Socket response received:", response);

            if (response.en === "MINI_LOTTERY_RESULTS_HISTORY") {
                let formattedData = [];

                if (Array.isArray(response.data)) {
                    formattedData = response.data.result;
                } else if (response.data && typeof response.data === "object") {
                    formattedData = Object.values(response.data.result);
                }
                setResultData(formattedData);
                setLoading(false);
            }
        };

        socket.on("res", handleResponse);

        return () => {
            socket.off("res", handleResponse);
        };
    }, [socket, fromDate]);

    // 🔍 Log whenever resultData updates

    // ✅ Checkbox handling logic
    const handleCheckboxChange = (e, check) => {
        let updated = field.map((fd) => {
            if (check.id === "all") {
                fd.Checked = e.target.checked;
            } else if (fd.id === check.id) {
                fd.Checked = e.target.checked;
            }
            return fd;
        });

        updated[0].Checked = updated.slice(1).every(fd => fd.Checked);

        setField([...updated]);
    };

    return (
        <div className="myaccount_content">
            {/* Date Filter Section */}
            {/* Date Filter */}
            <div className="flex items-center">
                <div className="w-full flex flex-wrap gap-2 items-center justify-between px-2 py-2">
                    <div className="w-full sm:w-1/4 px-2">
                        <div className="mb-4">
                            <label className="block text-gray-700 text-sm font-bold mb-2">
                                From
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700"
                                type="date"
                                value={fromDate}
                                onChange={(e) => setFromDate(e.target.value)}
                                max={moment().format("YYYY-MM-DD")}
                                min={"2023-04-01"}
                            />
                        </div>  
                    </div>

                    {/* Checkbox Filters */}
                    <div className="w-full sm:w-1/2 px-2">
                        <div className="mb-4 flex items-center mt-5">
                            {field.map((check) => (
                                <div className="flex mx-4" key={check.id}>
                                    <Checkbox4
                                        checked={check.Checked}
                                        id={check.id}
                                        onChange={(e) => handleCheckboxChange(e, check)}
                                    />
                                    {check.label}
                                </div>
                            ))}
                        </div>
                    </div>
                    
                    {/* <button
                        onClick={() => navigate('/result')}
                        className="bg-gray-800 hover:bg-gray-900 text-white py-1 px-3 text-sm rounded-lg"
                    >
                        10/30/50
                    </button> */}
                    <button
                        onClick={() => navigate('/result1d')}
                        className="bg-gray-800 hover:bg-gray-900 text-white py-1 px-3 text-sm rounded-lg"
                    >
                        2D
                    </button>
                    
                    <button
                        onClick={() => navigate('/result3d')}
                        className="bg-gray-800 hover:bg-gray-900 text-white py-1 px-3 text-sm rounded-lg"
                    >
                        3D
                    </button>
                    
                    <button
                        onClick={() => navigate('/result')}
                        className="bg-gray-800 hover:bg-gray-900 text-white py-1 px-3 text-sm rounded-lg"
                    >
                        4D Chart
                    </button>

                    <button
                        onClick={() => navigate('/resultPana')}
                        className="bg-gray-800 hover:bg-gray-900 text-white py-1 px-3 text-sm rounded-lg"
                    >
                        Pana
                    </button>
                    {/* <button
                        onClick={() => navigate('/resultTitli')}
                        className="bg-gray-800 hover:bg-gray-900 text-white py-1 px-3 text-sm rounded-lg"
                    >
                        Titli
                    </button> */}
                    <button
                        onClick={() => navigate(-1)}
                        className="bg-gray-800 hover:bg-gray-900 text-white py-1 px-3 text-sm rounded-lg"
                    >
                        Back
                    </button>
                </div>
            </div>

            {/* Table Section */}
            <div
                className="history_table_div  overflow-y-auto pb-16"
                ref={container}
            >
                <table className="table  table-borderless history_table">
                    <thead className="sticky top-0">
                        <tr>
                            <th className="border border-gray-300 dark:border-gray-600 border-[#000]">GAME TIME</th>
                            {[...Array(10)].map((_, colorIndex) => (
                                <th
                                    className={`game_result_his${colorIndex + 1} border border-gray-300 dark:border-gray-600 border-[#000]`}
                                    key={colorIndex}
                                >
                                    {field[1]?.Checked && <div>{colorIndex}</div>}
                                </th>
                            ))}
                        </tr>
                    </thead>

                    <tbody id="result_body">
                        {resultData.length === 0 ? (
                            <tr>
                                <td colSpan={11} className="text-center py-4 border border-gray-300 dark:border-gray-600 border-[#000]">
                                    No Result Found
                                </td>
                            </tr>
                        ) : (
                            resultData.map((result, resultIndex) => (
                                <tr key={resultIndex} className="border border-gray-300 dark:border-gray-600 border-[#000]">
                                    <td className={`border border-gray-300 dark:border-gray-600 border-[#000]`}>{result.time}</td>
                                    {Object.keys(result.result).map((objKey, objIndex) => (
                                    <td key={objIndex}>
                                        <div className="result_his_line">
                                            {[...Array(10)].map((_, i) => (
                                                field[i + 1].Checked && (
                                                    <div key={i} className={`result_span_10_series game_result_his${(i % 2) + 1}`}>
                                                        {result.result[objKey][i]}
                                                    </div>
                                                )
                                            ))}
                                        </div>
                                    </td>
                                ))}
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
}

export default ResultPage2d;
